// жанр должен соответствовать
// рефу в mobile/src/enums/ERefsApps.ts

export enum EAppsGenreEng {
	STRATEGY = 'strategy-games',
	LUCKY = 'lucky-games',
	ROLEPLAY = 'role-play-games',
	CASUAL = 'casual-games',
	LOGIC = 'logic-games',
	ROWS = 'games-3-in-row',
	EXTERNAL = 'external-games',
}
